<button class="btn btn-primary btn-sm" disabled>
    <span>{{ 'BUTTON_TEXT.CREATE_WAREHOUSE' | translate }}</span>
</button>
